module.exports = __webpack_public_path__ + "img/pic-03.3a7357a4.png";